module.exports = __webpack_public_path__ + "static/img/m12.f119506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m12.jpg
// module id = JM7p
// module chunks = 1